module.exports = __webpack_public_path__ + "img/icon.aff1de33.png";